import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header_for_mobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  // Listen to beforeinstallprompt event for PWA install prompt
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setDeferredPrompt(null);
        setShowInstall(false);
      });
    }
  };

  return (
    <header className="w-full h-20 bg-gradient-to-r from-blue-500 to-blue-300 text-black flex items-center justify-between px-4 shadow-md text-xl font-lato">
      <Link to="/">
  <h1>The Great Himalayas</h1>
</Link>

      {/* Hamburger icon */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
        className="flex flex-col justify-center items-center space-y-1.5 focus:outline-none"
      >
        <span className={`block h-0.5 w-6 bg-black transition-transform duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
        <span className={`block h-0.5 w-6 bg-black transition-opacity duration-300 ${menuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
        <span className={`block h-0.5 w-6 bg-black transition-transform duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
      </button>

      {/* Dropdown menu */}
      {menuOpen && (
        <nav className="absolute right-2 top-16 bg-white shadow-lg rounded-md w-36 flex flex-col p-2 space-y-2 z-50">
           <Link
            to="/userprofile"
            className="text-black text-base"
            onClick={() => setMenuOpen(false)}
          >
            Profile
          </Link>
           <Link
            to="/aboutus"
            className="text-black text-base"
            onClick={() => setMenuOpen(false)}
          >
            About Us
          </Link>
           <Link
            to="/contactus"
            className="text-black text-base"
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </Link>
          <Link
            to="/careers"
            className="text-black text-base"
            onClick={() => setMenuOpen(false)}
          >
            Careers
          </Link>
           <Link
            to="/partnerwithus"
            className="text-black text-base"
            onClick={() => setMenuOpen(false)}
          >
           Partner With Us
          </Link>
          <Link
    to="/install"
    className="text-black text-base"
    onClick={() => setMenuOpen(false)}
  >
    How to Install
  </Link>
          {showInstall && (
            <button
              onClick={() => {
                handleInstallClick();
                setMenuOpen(false);
              }}
              className="bg-blue-500 text-white rounded px-2 py-0 hover:bg-blue-600 transition"
            >
              Install
            </button>
          )}
        </nav>
      )}
    </header>
  );
};

export default Header_for_mobile;
